import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey } from '../../utils/keys';
import { useCachedMember } from '../cache';
export const useMember = (options) => {
    const { variables, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const memberKey = getMemberKey({ variables, fields });
    const memberPlaceHolder = useCachedMember(variables === null || variables === void 0 ? void 0 : variables.id);
    return useQuery(memberKey, () => client.members.get(variables, fields), {
        placeholderData: () => memberPlaceHolder,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useMember.js.map